export interface CompoundDefinition {
          label: string;
          min: string;
          max: string;
          sum: string;
        }
        
        export const COMPOUND_LIST: CompoundDefinition[] = [
          { label: 'THC', min: 'THCMin', max: 'THCMax', sum: 'THCPM' },
          { label: 'CBD', min: 'CBDMin', max: 'CBDMax', sum: 'CBDPM' },
          { label: 'CBN', min: 'CBNMin', max: 'CBNMax', sum: 'CBNPM' },
          { label: 'CBG', min: 'CBGMin', max: 'CBGMax', sum: 'CBGPM' },
          { label: 'CBC', min: 'CBCMin', max: 'CBCMax', sum: 'CBGPM' },
          { label: 'TERP', min: 'TERPMin', max: 'TERPMax', sum: 'TERPPM' }
        ];